export default __webpack_public_path__ + "static/media/netflix.9216d967.mp4";